module.exports = __webpack_public_path__ + "static/media/480.94724ff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-duster/dark/480.png
// module id = 2008
// module chunks = 2